<template>
    <div>
        <div class="lead">
            <div class="text-center">
                <font-awesome-icon
                    icon="fa-duotone fa-id-card"
                    size="5x"
                    class="text-primary"
                />
            </div>

            <div class="mt-3">
                {{
                    $t(
                        "Complete your verification by uploading a photo of your ID"
                    )
                }}
            </div>
        </div>

        <div class="mt-3">
            <div v-if="url">
                <b-btn
                    v-if="cordova"
                    @click="cordovaVerification"
                    variant="primary"
                    size="lg"
                    pill
                    block
                >
                    {{ $t("Start Verification") }}
                </b-btn>
                <a
                    v-else
                    target="_blank"
                    :href="url"
                    class="btn btn-primary btn-lg w-100 rounded-pill"
                >
                    {{ $t("Start Verification") }}
                </a>
            </div>
            <div v-else>
                <generic-loading />
            </div>
        </div>
        <div class="mt-3 small text-secondary">
            {{
                $t(
                    "We will redirect you to our verification partner who will guide you through the process. We will email you once verification is complete"
                )
            }}
        </div>

        <onboarding-verification-link />
    </div>
</template>


<script>
import { mapState } from "vuex";

import OnboardingVerificationLink from "@/components/onboarding/verification/OnboardingVerificationLink";

export default {
    data() {
        return {
            url: null,
        };
    },
    created() {
        this.api.post("/sumsub/getVerificationUrl").then((response) => {
            this.url = response?.data?.url;
        });
    },
    computed: {
        ...mapState("system", ["cordova"]),
    },
    methods: {
        cordovaVerification() {
            this.$store.dispatch("system/openBrowser", this.url);
        },
    },
    components: {
        OnboardingVerificationLink,
    },
};
</script>